// extracted by mini-css-extract-plugin
export default {"app":"App_app__K6SrQ","heading":"App_heading__MFlQE"};